<template>
  <div
    style="z-index: 999999999"
    v-loading.fullscreen="fullscreenLoading"
    element-loading-spinner="el-icon-loading"
    :element-loading-text="text"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '加载中...',
    },
    fullscreenLoading: {
      type: Boolean,
      default: false,
    },

  },
};
</script>
